
import { useToast } from "vue-toastification";
import { defineComponent } from "@vue/runtime-core";
import { HomeOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons-vue";

import Header from "../components/Header.vue";
import { parseDate } from "../utils/parseDate";
import Loading from "../components/Loading.vue";
import { toastError } from "../utils/toastError";
import { IPatientResponse } from "@/types/patients";
import { patientService } from "@/services/patients";

export default defineComponent({
  components: {
    Header,
    Loading,
    HomeOutlined,
    MailOutlined,
    PhoneOutlined,
  },
  data() {
    return {
      parseDate,
      patient: {} as IPatientResponse,
    };
  },
  setup() {
    const toast = useToast();
    const paramId = new URL(location.href).pathname.split("/")[2];
    return {
      toast,
      paramId,
    };
  },
  methods: {
    getPatient() {
      patientService
        .getPatient(Number(this.paramId))
        .then((data) => {
          if (data) {
            this.patient = data;
          }
        })
        .catch((err) => toastError(err));
    },
  },
  created() {
    this.getPatient();
  },
});
